import { useMemo, type ReactNode } from 'react'
import { PlatformContext, createPlatform } from '@shared/platform'

interface Props { children: ReactNode }

export const PlatformProvider = ({ children }: Props) => {
  const platform = useMemo(() => createPlatform(), [])
  return <PlatformContext.Provider value={platform}>{children}</PlatformContext.Provider>
}
